import { ErrorOrigin } from '../betslip-error';
import { PayoutError } from './payout-error';

export class EditBetNotAllowed extends PayoutError {
    constructor(errorMessage: string | undefined) {
        super();
        this.origin = ErrorOrigin.BetSlip;
        this.cashOutErrorMessage = errorMessage;
    }

    cashOutErrorMessage: string | undefined;
    name = 'EditBetNotAllowed';
}
